import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.375 39.375v-21h30V26.4a1.2 1.2 0 0 0 1.2 1.2h.6a1.2 1.2 0 0 0 1.2-1.2V9.375a3 3 0 0 0-3-3h-4.5v-1.5a1.5 1.5 0 1 0-3 0v1.5h-15v-1.5a1.5 1.5 0 1 0-3 0v1.5h-4.5a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3H22.8a1.2 1.2 0 0 0 1.2-1.2v-.6a1.2 1.2 0 0 0-1.2-1.2zm4.5-30v1.5a1.5 1.5 0 1 0 3 0v-1.5h15v1.5a1.5 1.5 0 1 0 3 0v-1.5h4.5v6h-30v-6z" }, null, -1),
    _createElementVNode("path", { d: "M40.8 36a7.2 7.2 0 1 0-7.2 7.2v2.4a9.6 9.6 0 1 1 0-19.2 9.6 9.6 0 0 1 0 19.2v-2.4a7.2 7.2 0 0 0 7.2-7.2" }, null, -1),
    _createElementVNode("path", { d: "M32.4 31.2a1.2 1.2 0 0 1 2.4 0v3.6h3.6a1.2 1.2 0 0 1 0 2.4h-4.32a1.68 1.68 0 0 1-1.645-1.34l-.035-.34z" }, null, -1)
  ]))]))
}
export default { render: render }